module.exports = __webpack_public_path__ + "img/icon-conversion-time.c94b0487.svg";